// Config

export const IS_SERVER = typeof window === 'undefined'

export const IS_LOCAL = process.env.API_ENV === 'local'

export const IS_DEV = process.env.API_ENV === 'dev' || process.env.API_ENV === 'exp'

export const IS_PROD = process.env.API_ENV === 'prod'

export const IS_TEST = process.env.NODE_ENV === 'test' || process.env.IS_TEST == 'true'

export const API_ROOT_URL = '/api'

// TODO(catriel): Check This
export const ROOT_DOMAIN = !IS_SERVER ? window.location.hostname : 'app.alphamap.com'

// set longer timeout for dev for experimental features
export const API_DEFAULT_TIMEOUT_MS = 1000 * 60 * (IS_LOCAL || IS_DEV ? 20 : 2) // 2 minutes prod
export const API_REPORTS_TIMEOUT_MS = 1000 * 60 * 5 // 5 minutes

const APP_SUBDOMAIN = 'app'
const ASSETS_SUBDOMAIN = 'assets'

const ASSETS_DOMAIN =
  !IS_SERVER && !IS_LOCAL
    ? window.location.hostname.replace(APP_SUBDOMAIN, ASSETS_SUBDOMAIN)
    : `${ASSETS_SUBDOMAIN}.dev.alphamap.com`

export const ASSETS_URL = `https://${ASSETS_DOMAIN}`

const SEGMENT_CDN_SUBDOMAIN = 's-cdn'
const SEGMENT_CDN_INTEGRATIONS_SUBDOMAIN = 's-cdng'
const SEGMENT_API_SUBDOMAIN = 's-api'

export const SEGMENT_CDN_DOMAIN =
  !IS_SERVER && !IS_LOCAL
    ? window.location.hostname.replace(APP_SUBDOMAIN, SEGMENT_CDN_SUBDOMAIN)
    : `${SEGMENT_CDN_SUBDOMAIN}.dev.alphamap.com`

export const SEGMENT_CDNG_DOMAIN =
  !IS_SERVER && !IS_LOCAL
    ? window.location.hostname.replace(APP_SUBDOMAIN, SEGMENT_CDN_INTEGRATIONS_SUBDOMAIN)
    : `${SEGMENT_CDN_INTEGRATIONS_SUBDOMAIN}.dev.alphamap.com`

export const SEGMENT_API_DOMAIN =
  !IS_SERVER && !IS_LOCAL
    ? window.location.hostname.replace(APP_SUBDOMAIN, SEGMENT_API_SUBDOMAIN)
    : `${SEGMENT_API_SUBDOMAIN}.dev.alphamap.com`

const getAppUrl = () => {
  if (IS_LOCAL) {
    return 'http://localhost:3000'
  }
  if (IS_DEV) {
    return 'https://app.dev.alphamap.com'
  }
  if (IS_PROD) {
    return 'https://app.alphamap.com'
  }

  return ''
}

export const APP_URL = getAppUrl()
